import FileGalleryPageContainer from './FileGalleryPageContainer'
import FileGalleryPage from './FileGalleryPage'
export { FileGalleryPage }
export { FileGalleryPageContainer }
export default FileGalleryPageContainer



// WEBPACK FOOTER //
// ./src/pages/FileGalleryPage/index.js